import React from 'react';
import { SnbMenuItem } from '@components/common/snb/elements';

const SnbMenuList = ({ depth, menus }) => {
  const menuClassName = depth <= 1 ? 'lnb' : `navDepth${depth}`;

  return (
    <ul className={menuClassName}>
      {menus.map((menu, index) => (
        <SnbMenuItem depth={depth} menu={menu} key={index} />
      ))}
      {depth === 1 && $utils.isExternal && !$utils.isTablet && (
        <SnbMenuItem
          depth={1}
          menu={{
            linkMenuYn: 'N',
            ssoLinkdYn: 'N',
            path: '/installPop',
            label: '설치 프로그램',
            icon: 'library',
          }}
        />
      )}
    </ul>
  );
};

SnbMenuList.propTypes = {
  depth: $propTypes.number,
  menus: $propTypes.array,
};

SnbMenuList.defaultProps = {
  depth: 1,
  menus: [],
};

export default SnbMenuList;
